module.exports = __webpack_public_path__ + "img/1280.8123f7d4.svg";